/* unplugin-vue-components disabled */import { render } from "./CountDownGadge.vue?vue&type=template&id=ff778c3a"
import script from "./CountDownGadge.vue?vue&type=script&lang=js"
export * from "./CountDownGadge.vue?vue&type=script&lang=js"

import "./CountDownGadge.vue?vue&type=style&index=0&id=ff778c3a&lang=scss"
script.render = render

export default script